import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/arrow_right_light.svg")